const APIURl = 'http://localhost:5000'
module.exports = {
    APIURl: APIURl,
}
